class JMPLans {
    constructor() {
    }

    init() {
        console.log('JMPLans initialized');
        // First drawer render (SSR checkboxes appear)
        document.addEventListener('theme:cart:loaded', this.addInputListeners);

        // After any AJAX cart rebuild (add / qty change / remove)
        document.addEventListener('theme:cart:added', this.addInputListeners);
        document.addEventListener('click', this.handleTooltipClick);
    }
    addInputListeners = () => {
        const planElements = document.querySelectorAll('.cart-drawer__items .cart-jm-3yr, .cart-drawer__items .cart-jm-lifetime');
        planElements.forEach(element => {
            element.addEventListener('click', this.handlePlanClick);
        });
        console.log('JM: addInputListeners');
    }
    handleTooltipClick = (event) => {
      const trigger = event.target.closest('.jm-tooltip-text');
      if (trigger) {
        const tooltip = trigger.querySelector('.care-plan-tooltip');
        const isOpen = tooltip?.classList.contains('is-open');
        // Close all, then toggle this one open if it wasn't already
        this.closeAllTooltips();
        if (!isOpen) {
          tooltip?.classList.add('is-open');
        }
        return;
      }
      // Click outside any trigger → close all
      if (!event.target.closest('.care-plan-tooltip')) {
        this.closeAllTooltips();
      }
    }
    closeAllTooltips = () => {
      document.querySelectorAll('.care-plan-tooltip.is-open')?.forEach(tooltip => tooltip.classList.remove('is-open'));
    }
    handlePlanClick = async (event) => {
        console.log('JM: handlePlanClick');
        const data = {
          associatedSku: event.target.dataset.associatedSku,
          vid: event.target.dataset.vid,
          baseVid: event.target.dataset.baseVid,
          sku: event.target.dataset.sku,
          uuid: this.uuidv4()
        };

        console.log('JM: data: ', data);
        if (event.target.checked) {
            await this.addPlanToCart(data);
            await this.addLineItemProperty(data);
            
        } else {
            await this.removePlanFromCart(data);
            await this.removeLineItemProperty(data);
        }

        if (window.cart && typeof window.cart.getCart === 'function') {
          window.cart.getCart();
        }
    }

    addPlanToCart = async (data) => {
      try {
        const res = await fetch("/cart/add.json", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            "Accept": "application/json"
          },
          body: JSON.stringify({
            id: data.vid,
            quantity: 1,
            properties: {
              associatedSku: data.associatedSku,
              uuid: data.uuid
            }
          })
        });
        console.log('JM: res: ', res);
      } catch (err) {
        console.error('error caught in addPlanToCart, err: ', err);
      }
    }
    updateBaseLineItemProperty = async (data, properties) => {
      const currentCart = await this.getCart();
      if (!currentCart) {
        console.error('currentCart not found in updateLineItemProperty');
        return;
      }
      const ringInCart = currentCart.items.find((product) => {
        return product.sku === data.associatedSku
      });

      if (!ringInCart) {
        console.error('ringInCart not found in addLineItemProperty, associatedSku: ', data.associatedSku);
        return;
      }

      const updatedProperties = {
        ...ringInCart.properties,
        ...properties
      }

      try {
        const res = await fetch("/cart/change.json", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            "Accept": "application/json"
          },
          body: JSON.stringify({
            id: data.baseVid,
            properties: updatedProperties
          })
        });
        console.log('JM: res: ', res);
      } catch (err) {
        console.error('error caught in addLineItemProperty, err: ', err);
      }
      
    }
    removeLineItemProperty = async (data) => {
      await this.updateBaseLineItemProperty(data, {});
      
    }
    addLineItemProperty = async (data) => {
      await this.updateBaseLineItemProperty(data, { uuid: data.uuid });
    }

    removePlanFromCart = async (data) => {
          const currentCart = await this.getCart();
          if (!currentCart) {
            console.error('currentCart not found in removePlanFromCart');
            return;
          }

          const matchingProduct = currentCart.items.find((item) => {
            return item.sku === data.sku;
          });

          if (!matchingProduct) {
            console.error('matching product not found in removing JM item! matchingProduct: ', matchingProduct);
            return;
          }

          try {
            const res = await fetch("/cart/change.json", {
              method: "POST",
              headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
              },
              body: JSON.stringify({
                id: data.vid,
                quantity: 0
              })
            });
          console.log('JM: res: ', res);
        } catch (err) {
          console.error('error caught in removePlanFromCart, err: ', err);
        }
    }

    uuidv4() {
        return "10000000-1000-4000-8000-100000000000".replace(/[018]/g, c =>
            (+c ^ crypto.getRandomValues(new Uint8Array(1))[0] & 15 >> +c / 4).toString(16)
        );
    }
    getCart = async () => {
      try {
      const result = await fetch("/cart.json");

      if (result.status === 200) {
        return result.json();
      }

      return null;
        
      } catch (err) {
        console.error('error caught in getCart, err: ', err);
        return null;
      }
    }
}

(function() {
  const jmPlans = new JMPLans();
  jmPlans.init();
})();
